import React, {
  createContext,
  useContext,
  useEffect,
  useState,
  useMemo,
} from "react";
import userAPI from "../api/userApi";

const SiteConfigContext = createContext();

export const SiteConfigProvider = ({ children }) => {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSiteDetails();
  }, []);

  const fetchSiteDetails = async () => {
    try {
      const cachedConfig = sessionStorage.getItem("site_config");

      if (cachedConfig) {
        const parsed = JSON.parse(cachedConfig);
        const isExpired = Date.now() - parsed.timestamp > 5 * 60 * 1000; // 5 min cache

        if (!isExpired) {
          setConfig(parsed.data);
          setLoading(false);
          return;
        }
      }

      const res = await userAPI.details();

      if (res.code === 200) {
        setConfig(res.data);
        sessionStorage.setItem(
          "site_config",
          JSON.stringify({ data: res.data, timestamp: Date.now() }),
        );
      }
    } catch (err) {
      console.error("Failed to fetch site config", err);
    } finally {
      setLoading(false);
    }
  };

  const siteConfig = useMemo(
    () => ({
      siteName: config?.school_name || "MRV School",
      logo: config?.logo || "/logo.png",
      description: config?.description || "",
      phone: config?.phone || "",
      landline1: config?.landline1 || "",
      landline2: config?.landline2 || "",
      whatsapp: config?.whatsapp || "",
      email: config?.school_email || "",
      address: config?.address || "",
      workingHours: config?.working_hours || "",
      mapEmbed: config?.map_embed || "",
      schoolhours: config?.schoolhours || "",
      admission_batch: config?.admission_batch || "",
      erp_registration_link: config?.erp_registration_link || "",
      socialMedia: {
        facebook: config?.facebook || "",
        instagram: config?.instagram || "",
        twitter: config?.twitter || "",
        youtube: config?.youtube || "",
      },
    }),
    [config],
  );

  return (
    <SiteConfigContext.Provider value={{ siteConfig, loading }}>
      {children}
    </SiteConfigContext.Provider>
  );
};

export const useSiteConfig = () => useContext(SiteConfigContext);
